var render = function () {
  var _vm$itemRevenuesV;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('Toast'), _c('HeaderBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'Publisher',
        to: '/vendor'
      }, {
        label: 'Edit'
      }],
      "title": "Edit Publisher"
    }
  }), _c('div', {
    staticClass: "flex items-center px-4 py-3 my-3 space-x-4 bg-white rounded-lg shadow-sm tab-header"
  }, [_c('div', {
    class: ['tab-item flex items-center', {
      'text-blue-500 font-semibold': _vm.currentTab === 1
    }]
  }, [_c('span', {
    class: ['font-bold rounded-full border p-1.5 mr-2 text-center w-9 h-9', {
      'border-custom': _vm.currentTab === 1
    }]
  }, [_vm._v("1")]), _vm._v(" Publisher Details ")]), _c('span', {
    staticClass: "text-gray-400"
  }, [_vm._v("»")]), _c('div', {
    class: ['tab-item flex items-center', {
      'text-blue-500 font-semibold': _vm.currentTab === 2
    }]
  }, [_c('span', {
    class: ['font-bold rounded-full border p-1.5 mr-2 text-center w-9 h-9', {
      'border-custom': _vm.currentTab === 2
    }]
  }, [_vm._v("2")]), _vm._v(" Publisher Agreement ")]), _c('span', {
    staticClass: "text-gray-400"
  }, [_vm._v("»")]), _c('div', {
    class: ['tab-item flex items-center', {
      'text-blue-500 font-semibold': _vm.currentTab === 3
    }]
  }, [_c('span', {
    class: ['font-bold rounded-full border p-1.5 mr-2 text-center w-9 h-9', {
      'border-custom': _vm.currentTab === 3
    }]
  }, [_vm._v("3")]), _vm._v(" Publisher Report Format ")])]), _c('div', {
    staticClass: "flex-col w-full mb-3 bg-white rounded-lg"
  }, [_vm.currentTab === 1 ? _c('div', {
    staticClass: "flex items-center justify-between w-full px-4 py-3 mt-3 rounded-lg"
  }, [_c('div', {
    staticClass: "flex flex-col w-1/2"
  }, [_c('FormLabel', {
    attrs: {
      "htmlFor": "vendor-name"
    }
  }, [_vm._v(" Publisher Name ")]), _c('TextInput', {
    attrs: {
      "type": "text",
      "id": "vendor-name",
      "placeholder": "Enter Vendor Name",
      "variant": _vm.isSubmitted && _vm.isNameError ? 'error' : 'default'
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  }), _vm.isSubmitted && _vm.isNameError ? _c('div', {
    staticClass: "mt-1 text-sm text-red-500"
  }, [_vm._v("Must be filled.")]) : _vm._e(), _c('FormLabel', {
    attrs: {
      "htmlFor": "vendor-name",
      "className": "mt-3"
    }
  }, [_vm._v(" Publisher Image (Optional) ")]), _c('div', [_c('label', {
    staticClass: "rounded-lg cursor-pointer",
    attrs: {
      "for": "input-image"
    }
  }, [_vm.form.preview ? _c('img', {
    staticClass: "object-contain rounded-lg img-fluid",
    staticStyle: {
      "height": "144px",
      "width": "144px"
    },
    attrs: {
      "src": _vm.form.preview,
      "height": "144",
      "width": "144"
    }
  }) : _c('div', {
    class: ['flex flex-col items-center bg-gray-50 border-2 px-1 border-gray-200 hover:border-gray-400 border-dashed rounded-lg gap-2'],
    staticStyle: {
      "height": "144px",
      "width": "144px",
      "padding-top": "37px"
    }
  }, [_c('FileCirlclePlusFilled'), _c('div', {
    staticClass: "text-xs font-semibold text-gray-500"
  }, [_vm._v(" Upload Image ")]), _c('div', {
    staticClass: "text-xs font-normal text-gray-500"
  }, [_vm._v(" Max 2MB ")])], 1)])]), _c('input', {
    staticClass: "hidden",
    attrs: {
      "id": "input-image",
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.previewImage
    }
  }), _c('FormLabel', {
    attrs: {
      "htmlFor": "organization",
      "className": "mt-3"
    }
  }, [_vm._v(" Organization ")]), _c('multiselect', {
    staticClass: "box-border custom-multiselect",
    class: _vm.isSubmitted && _vm.isOrganizationError ? 'error' : '',
    attrs: {
      "label": "name",
      "track-by": "name",
      "placeholder": "Select Organization",
      "open-direction": "bottom",
      "options": _vm.organizationOptions,
      "searchable": true,
      "loading": _vm.isLoadingOrganization,
      "close-on-select": true
    },
    on: {
      "search-change": _vm.handleSearchOrganization
    },
    model: {
      value: _vm.form.organization,
      callback: function ($$v) {
        _vm.$set(_vm.form, "organization", $$v);
      },
      expression: "form.organization"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v(" Oops! No elements found. Consider changing the search query. ")])]), _vm.isSubmitted && _vm.isOrganizationError ? _c('div', {
    staticClass: "mt-1 text-sm text-red-500"
  }, [_vm._v("Must be filled.")]) : _vm._e(), _c('FormLabel', {
    attrs: {
      "htmlFor": "isExternal",
      "className": "mt-3"
    }
  }, [_vm._v(" Publisher Type ")]), _c('SelectRadio', {
    attrs: {
      "id": "isExternal",
      "defaultText": "Select Publisher Type",
      "options": _vm.vendorTypeOptions,
      "isError": _vm.isSubmitted && _vm.isExternalError
    },
    model: {
      value: _vm.form.isExternal,
      callback: function ($$v) {
        _vm.$set(_vm.form, "isExternal", $$v);
      },
      expression: "form.isExternal"
    }
  }), _vm.isSubmitted && _vm.isExternalError ? _c('div', {
    staticClass: "mt-1 text-sm text-red-500"
  }, [_vm._v("Must be filled.")]) : _vm._e(), _c('FormLabel', {
    attrs: {
      "htmlFor": "vendorSource",
      "className": "mt-3"
    }
  }, [_vm._v(" Vendor Source ")]), _c('SelectRadio', {
    attrs: {
      "id": "vendorSource",
      "defaultText": "Select Publisher Source",
      "options": _vm.vendorSourceOptions,
      "isError": _vm.isSubmitted && _vm.isVendorSourceError
    },
    model: {
      value: _vm.form.vendorSource,
      callback: function ($$v) {
        _vm.$set(_vm.form, "vendorSource", $$v);
      },
      expression: "form.vendorSource"
    }
  }), _vm.isSubmitted && _vm.isVendorSourceError ? _c('div', {
    staticClass: "mt-1 text-sm text-red-500"
  }, [_vm._v("Must be filled.")]) : _vm._e(), _c('FormLabel', {
    attrs: {
      "htmlFor": "vendorSource",
      "className": "mt-3"
    }
  }, [_vm._v(" Publisher Content (Optional) ")]), _c('SelectCheckbox', {
    attrs: {
      "id": "vendorContent",
      "defaultText": "Select Publisher Content",
      "options": _vm.contentTypeOptions
    },
    model: {
      value: _vm.form.contentTypes,
      callback: function ($$v) {
        _vm.$set(_vm.form, "contentTypes", $$v);
      },
      expression: "form.contentTypes"
    }
  }), _c('FormLabel', {
    attrs: {
      "htmlFor": "status",
      "className": "mt-3"
    }
  }, [_vm._v(" Approval Status ")]), _c('SelectRadio', {
    attrs: {
      "id": "status",
      "defaultText": "Select Approval Status",
      "options": _vm.statusOptions,
      "isError": _vm.isSubmitted && _vm.isStatusError
    },
    model: {
      value: _vm.form.status,
      callback: function ($$v) {
        _vm.$set(_vm.form, "status", $$v);
      },
      expression: "form.status"
    }
  }), _vm.isSubmitted && _vm.isStatusError ? _c('div', {
    staticClass: "mt-1 text-sm text-red-500"
  }, [_vm._v("Must be filled.")]) : _vm._e(), _c('FormLabel', {
    attrs: {
      "htmlFor": "vendorId",
      "className": "mt-3"
    }
  }, [_vm._v(" Vendor ID from AX ")]), _c('TextInput', {
    attrs: {
      "type": "text",
      "id": "vendorId",
      "placeholder": "Enter Publisher ID from AX",
      "variant": _vm.isSubmitted && _vm.isVendorIdAxError ? 'error' : 'default'
    },
    model: {
      value: _vm.form.vendorIdAx,
      callback: function ($$v) {
        _vm.$set(_vm.form, "vendorIdAx", $$v);
      },
      expression: "form.vendorIdAx"
    }
  }), _vm.isSubmitted && _vm.isVendorIdAxError ? _c('div', {
    staticClass: "mt-1 text-sm text-red-500"
  }, [_vm._v("Must be filled.")]) : _vm._e(), _c('FormLabel', {
    attrs: {
      "htmlFor": "description",
      "className": "mt-3"
    }
  }, [_vm._v(" Description (Optional) ")]), _c('TextArea', {
    attrs: {
      "id": "description",
      "rows": "7",
      "placeholder": "Enter something..."
    },
    model: {
      value: _vm.form.description,
      callback: function ($$v) {
        _vm.$set(_vm.form, "description", $$v);
      },
      expression: "form.description"
    }
  }), _c('FormLabel', {
    attrs: {
      "htmlFor": "status",
      "className": "mt-3"
    }
  }, [_vm._v(" Status ")]), _c('GmSwitch', {
    attrs: {
      "id": "status"
    },
    model: {
      value: _vm.form.isActive,
      callback: function ($$v) {
        _vm.$set(_vm.form, "isActive", $$v);
      },
      expression: "form.isActive"
    }
  }), _c('div', {
    staticClass: "flex gap-5 mt-2"
  }, [_c('Button', {
    on: {
      "click": _vm.validateAndNext
    }
  }, [_vm._v(" Next ")]), _c('Button', {
    attrs: {
      "variant": "outlined",
      "color": "alternative"
    },
    on: {
      "click": _vm.prevTab
    }
  }, [_vm._v(" Cancel ")])], 1)], 1)]) : _vm._e(), _vm.currentTab === 2 ? _c('div', {
    staticClass: "flex items-center justify-between w-full px-4 py-3 mt-3 rounded-lg"
  }, [_c('div', {
    staticClass: "w-full"
  }, [_c('Table', {
    attrs: {
      "headers": _vm.vATableHeaders,
      "data": (_vm$itemRevenuesV = _vm.itemRevenuesV2) !== null && _vm$itemRevenuesV !== void 0 ? _vm$itemRevenuesV : [],
      "rowKey": _vm.vaTableRowKeys,
      "currentPage": _vm.vACurrentPage,
      "perPage": _vm.vATablePerPage,
      "isLoading": _vm.vAIsLoading,
      "withNumberCol": false,
      "withTopRow": true,
      "className": "w-full"
    },
    scopedSlots: _vm._u([{
      key: "top-row",
      fn: function () {
        return [_c('td', {
          staticClass: "p-2 text-left create-cell"
        }, [_c('Button', {
          attrs: {
            "variant": "outlined",
            "color": "primary",
            "size": "xs",
            "className": "w-full"
          },
          on: {
            "click": _vm.createVendorAgreement
          }
        }, [_c('div', {
          staticClass: "flex items-center justify-center"
        }, [_c('PlusOutline', {
          attrs: {
            "className": "w-3 h-3 mr-1 text-blue-700"
          }
        }), _vm._v(" Add New ")], 1)])], 1)];
      },
      proxy: true
    }, {
      key: "default_percentage_amount",
      fn: function (_ref) {
        var value = _ref.value;
        return [_vm._v(" " + _vm._s(value * 100) + "% ")];
      }
    }, {
      key: "valid_from",
      fn: function (_ref2) {
        var value = _ref2.value;
        return [_c('div', [_vm._v(" " + _vm._s(_vm.formatAgreementDate(value)) + " ")]), _c('div', {
          staticClass: "text-xs italic text-gray-500"
        }, [_vm._v(" " + _vm._s(_vm.formatAgreementTime(value)) + " ")])];
      }
    }, {
      key: "valid_to",
      fn: function (_ref3) {
        var value = _ref3.value;
        return [_c('div', [_vm._v(" " + _vm._s(_vm.formatAgreementDate(value)) + " ")]), _c('div', {
          staticClass: "text-xs italic text-gray-500"
        }, [_vm._v(" " + _vm._s(_vm.formatAgreementTime(value)) + " ")])];
      }
    }, {
      key: "is_active",
      fn: function (_ref4) {
        var value = _ref4.value;
        return [_c('div', [_c('Label', {
          attrs: {
            "variant": value ? 'green' : 'gray'
          }
        }, [_vm._v(" " + _vm._s(value ? 'Active' : 'Inactive') + " ")])], 1)];
      }
    }, {
      key: "actions",
      fn: function (_ref5) {
        var row = _ref5.row;
        return [_c('router-link', {
          staticClass: "inline-block mx-auto",
          attrs: {
            "to": {
              path: ("/vendor/edit/" + (row.vendor_id) + "/agreement/edit/" + (row.id))
            },
            "title": "Edit"
          }
        }, [_c('EditFilled')], 1)];
      }
    }], null, false, 2291943960)
  }), !!Number(_vm.itemRevenuesV2TotalRows) ? _c('div', {
    staticClass: "flex justify-between pt-4 pl-3 pr-3 mt-1 mb-2 bg-white border-t border-gray-100"
  }, [_c('div', {
    staticClass: "font-semibold"
  }, [_c('span', {
    staticClass: "font-normal text-gray-500"
  }, [_vm._v("Showing ")]), _vm._v(" " + _vm._s(_vm.vACurrentPage) + "-" + _vm._s(Number(_vm.itemRevenuesV2TotalRows) >= _vm.vATablePerPage ? _vm.vATablePerPage : Number(_vm.itemRevenuesV2TotalRows)) + " "), _c('span', {
    staticClass: "font-normal text-gray-500"
  }, [_vm._v("of")]), _vm._v(" " + _vm._s(parseInt(_vm.itemRevenuesV2TotalRows)) + " ")]), _c('div', {
    staticClass: "mb-2"
  }, [_c('t-pagination', {
    attrs: {
      "disabled": _vm.vAIsLoading,
      "total-items": Number(_vm.itemRevenuesV2TotalRows),
      "per-page": _vm.vATablePerPage
    },
    on: {
      "change": _vm.vAOnClickPage
    },
    model: {
      value: _vm.vACurrentPage,
      callback: function ($$v) {
        _vm.vACurrentPage = $$v;
      },
      expression: "vACurrentPage"
    }
  })], 1)]) : _vm._e(), _c('div', {
    staticClass: "flex gap-5 mt-2"
  }, [_c('Button', {
    on: {
      "click": _vm.validateAndNext
    }
  }, [_vm._v(" Next ")]), _c('Button', {
    attrs: {
      "variant": "outlined",
      "color": "alternative"
    },
    on: {
      "click": _vm.prevTab
    }
  }, [_vm._v(" Back ")])], 1)], 1)]) : _vm._e(), _vm.currentTab === 3 ? _c('div', {
    staticClass: "flex items-center justify-between w-full px-4 py-3 mt-3 rounded-lg"
  }, [_c('div', {
    staticClass: "flex flex-col w-1/2"
  }, [_c('FormLabel', {
    attrs: {
      "htmlFor": "contentType"
    }
  }, [_vm._v(" Content Type ")]), _c('div', {
    staticClass: "flex gap-6"
  }, [_c('b-form-checkbox', {
    attrs: {
      "unchecked-value": false
    },
    model: {
      value: _vm.form.vRFIsSingle,
      callback: function ($$v) {
        _vm.$set(_vm.form, "vRFIsSingle", $$v);
      },
      expression: "form.vRFIsSingle"
    }
  }, [_vm._v(" Single ")]), _c('b-form-checkbox', {
    attrs: {
      "unchecked-value": false
    },
    model: {
      value: _vm.form.vRFIsBundle,
      callback: function ($$v) {
        _vm.$set(_vm.form, "vRFIsBundle", $$v);
      },
      expression: "form.vRFIsBundle"
    }
  }, [_vm._v(" Bundle ")]), _c('b-form-checkbox', {
    attrs: {
      "unchecked-value": false
    },
    model: {
      value: _vm.form.vRFIsSubscription,
      callback: function ($$v) {
        _vm.$set(_vm.form, "vRFIsSubscription", $$v);
      },
      expression: "form.vRFIsSubscription"
    }
  }, [_vm._v(" Subscription ")]), _c('b-form-checkbox', {
    attrs: {
      "unchecked-value": false
    },
    model: {
      value: _vm.form.vRFIsBuffet,
      callback: function ($$v) {
        _vm.$set(_vm.form, "vRFIsBuffet", $$v);
      },
      expression: "form.vRFIsBuffet"
    }
  }, [_vm._v(" Buffet ")])], 1), _c('FormLabel', {
    staticClass: "mt-3",
    attrs: {
      "htmlFor": "reason"
    }
  }, [_vm._v(" Reason (Optional) ")]), _c('TextArea', {
    attrs: {
      "id": "reason",
      "rows": "7",
      "placeholder": "Type reason here..."
    },
    model: {
      value: _vm.form.vRFReason,
      callback: function ($$v) {
        _vm.$set(_vm.form, "vRFReason", $$v);
      },
      expression: "form.vRFReason"
    }
  }), _c('FormLabel', {
    staticClass: "mt-3",
    attrs: {
      "htmlFor": "status"
    }
  }, [_vm._v(" Status ")]), _c('GmSwitch', {
    attrs: {
      "id": "status"
    },
    model: {
      value: _vm.form.vRFIsActive,
      callback: function ($$v) {
        _vm.$set(_vm.form, "vRFIsActive", $$v);
      },
      expression: "form.vRFIsActive"
    }
  }), _c('div', {
    staticClass: "flex gap-5 mt-4"
  }, [_c('Button', {
    on: {
      "click": _vm.updateVendor
    }
  }, [_vm._v(" Save ")]), _c('Button', {
    attrs: {
      "variant": "outlined",
      "color": "alternative"
    },
    on: {
      "click": _vm.prevTab
    }
  }, [_vm._v(" Back ")])], 1)], 1)]) : _vm._e()])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }